import { InstanceScreen } from 'component/navigation/instance';

export default function RankingEvalCustomRankersScreen() {
    return <InstanceScreen screenKey='custom-rankers' />;
}
